import type { InjectedRouter } from 'js/lib/connectToRouter';

import { ALGOLIA_PROD_RESULTS_INDEX } from 'bundles/search-common/constants';
import {
  COURSE,
  DEGREE,
  GUIDED_PROJECT,
  MASTERTRACK,
  PROFESSIONAL_CERTIFICATE,
  SPECIALIZATION_ENTITY_TYPE,
} from 'bundles/search-common/constants/entityTypes';

import _t from 'i18n!nls/seo-entity-page';

export const SEARCH_PAGE_ENTITY_TYPES = [
  PROFESSIONAL_CERTIFICATE,
  SPECIALIZATION_ENTITY_TYPE,
  COURSE,
  GUIDED_PROJECT,
  DEGREE,
  MASTERTRACK,
] as const;

export const getEntityTypeToDataMapping = () => {
  return {
    [PROFESSIONAL_CERTIFICATE]: {
      prettyName: _t('Professional Certificates'),
      refinementId: 'Professional Certificates',
      subtitle: _t(
        'Earn career credentials from industry leaders and showcase what you’ve learned with portfolio projects.'
      ),
    },
    [SPECIALIZATION_ENTITY_TYPE]: {
      prettyName: _t('Specializations'),
      refinementId: 'Specializations',
      subtitle: _t('Master a new skill with a series of curated courses.'),
    },
    [COURSE]: {
      prettyName: _t('Courses'),
      refinementId: 'Courses',
      subtitle: _t('Learn something new from top instructors with graded assignments, videos, and  feedback.'),
    },
    [GUIDED_PROJECT]: {
      prettyName: _t('Guided Projects'),
      refinementId: 'Rhyme Projects',
      subtitle: _t('Learn a job-relevant skill in under 2 hours with a hands-on tutorial.'),
    },
    [DEGREE]: {
      prettyName: _t('Degrees'),
      refinementId: 'Degrees',
      subtitle: _t('Earn a bachelor’s or master’s degree online from a top university.'),
    },
    [MASTERTRACK]: {
      prettyName: _t('Mastertracks'),
      refinementId: 'MasterTrack® Certificates',
      subtitle: _t(
        'Earn university-issued credentials and credits towards a master’s degree with interactive online learning.'
      ),
    },
  };
};

export const getEntityTypeResults = (entityType: string, allResults?: Array<Record<string, any>>) => {
  return allResults?.filter((result) => result.entityType === entityType);
};

export const getCurrentEntityPageNum = (router: InjectedRouter) => {
  const hasPageQuery = router?.location?.query?.[`indices[${ALGOLIA_PROD_RESULTS_INDEX}][page]`];
  const queryPageNum = Number(hasPageQuery);
  const currentPage: number = queryPageNum > 1 ? queryPageNum : 1;
  return currentPage;
};
